import z from "zod";

export const athenaHealthAuthPath = "/athena/app";
export const canvasAuthPath = "/canvas/app";
export const elationAuthPath = "/elation/app";
export const healthieAuthPath = "/healthie/app";
export const eclinicalworksAuthPath = "/eclinicalworks/app";
export const salesforceAuthPath = "/salesforce/app";
export const practicefusionAuthPath = "/practicefusion/app";

// Patient scoped
export const authPaths = [
  athenaHealthAuthPath,
  canvasAuthPath,
  elationAuthPath,
  healthieAuthPath,
  eclinicalworksAuthPath,
  salesforceAuthPath,
  practicefusionAuthPath,
];

export const authPathSchema = z.object({
  authPath: z.enum(authPaths as [string, ...string[]]),
});
export type EhrAuthPath = z.infer<typeof authPathSchema>;

// Page scoped
export const embedAuthPath = "/embed/app" as const;
const embedRoutes = {
  tcm: z.literal("/transitions-of-care").transform(() => ({
    route: "transitions-of-care" as const,
  })),
  patient: z
    .string()
    .regex(/^\/patient\/[0-9a-f-]+$/i)
    .transform(path => ({
      route: "patient" as const,
      patientId: z.string().uuid().parse(path.split("/")[2]),
    })),
};

const embedSubPathSchema = z.union([embedRoutes.tcm, embedRoutes.patient]);

export const pageAuthPaths = [embedAuthPath] as const;
export type PageAuthPath = (typeof pageAuthPaths)[number];
export const pageAuthPathSchema = z.string().transform((fullPath, ctx) => {
  if (!fullPath.startsWith(embedAuthPath)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: "Invalid base path" });
    return z.NEVER;
  }
  const subPath = fullPath.slice(embedAuthPath.length);
  const subRoute = embedSubPathSchema.parse(subPath);
  return { basePath: embedAuthPath, fullPath, ...subRoute };
});

export type ParsedPageAuthPath = z.infer<typeof pageAuthPathSchema>;
// Quick check if path is page-scoped (for guards, no parsing needed)
export function isPageAuthPath(path: string): path is PageAuthPath {
  return pageAuthPaths.some(base => path.startsWith(base));
}
